// extracted by mini-css-extract-plugin
export default {"contents":"OF-z","sectionHeading":"PF-z"};